<div class="container">
  <mat-card>
    <div class="layout-row responsive-column gap-20px">
      <div class="flex-50">
        <mat-nav-list>
          <div #datatables>
            <mat-list-item [routerLink]="['data-tables']">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['data-tables']">
                  <mat-icon matListIcon>
                    <fa-icon icon="table" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Manage Data tables' | translate }}
                    @if (arrowBooleans[0]) {
                      <p matLine [routerLink]="['data-tables']" class="menu-explanation">
                        {{ 'labels.text.Add new extra fields to any entity' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[0]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(0); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[0]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(0); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #codes>
            <mat-list-item matListIcon [routerLink]="['codes']">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['codes']">
                  <mat-icon matListIcon>
                    <fa-icon icon="list-ul" size="sm"></fa-icon>
                  </mat-icon>
                  <div>
                    {{ 'labels.heading.Manage Codes' | translate }}
                    @if (arrowBooleans[1]) {
                      <p matLine [routerLink]="['codes']" class="menu-explanation">
                        {{ 'labels.text.Codes are used to define drop down values' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[1]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(1); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[1]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(1); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #rolesandpermission>
            <mat-list-item [routerLink]="['roles-and-permissions']">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['roles-and-permissions']">
                  <mat-icon matListIcon>
                    <fa-icon icon="key" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Manage Roles and Permissions' | translate }}
                    @if (arrowBooleans[2]) {
                      <p matLine [routerLink]="['roles-and-permissions']" class="menu-explanation">
                        {{ 'labels.text.Define or modify roles and associated permissions' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[2]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(2); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[2]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(2); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <div #makerCheckerTable>
            <mat-list-item [routerLink]="['configure-mc-tasks']">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['configure-mc-tasks']">
                  <mat-icon matListIcon>
                    <fa-icon icon="sitemap" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine [routerLink]="['configure-mc-tasks']">
                    {{ 'labels.heading.Configure Maker Checker Tasks' | translate }}
                    @if (arrowBooleans[3]) {
                      <p matLine [routerLink]="['configure-mc-tasks']" class="menu-explanation">
                        {{ 'labels.text.Define or modify Maker Checker tasks' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[3]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(3); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[3]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(3); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <mat-list-item [routerLink]="['hooks']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['hooks']">
                <mat-icon matListIcon>
                  <fa-icon icon="anchor" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Manage Hooks' | translate }}
                  @if (arrowBooleans[4]) {
                    <p matLine [routerLink]="['hooks']" class="menu-explanation">
                      {{ 'labels.text.Define Hooks' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[4]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(4); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[4]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(4); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [routerLink]="['entity-to-entity-mapping']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['entity-to-entity-mapping']">
                <mat-icon matListIcon>
                  <fa-icon icon="road" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Entity to Entity Mapping' | translate }}
                  @if (arrowBooleans[5]) {
                    <p matLine [routerLink]="['entity-to-entity-mapping']" class="menu-explanation">
                      {{ 'labels.text.Define or modify entity to entity mappings' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[5]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(5); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[5]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(5); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [ngClass]="{ 'disabled-item': isDisabled }">
            <div class="menu-list-item-content">
              <div class="menu-left-section">
                <mat-icon matListIcon>
                  <fa-icon icon="file-alt" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Manage Surveys' | translate }}
                  @if (arrowBooleans[6]) {
                    <p matLine class="menu-explanation">
                      {{ 'labels.text.Manage Surveys' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[6]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(6); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[6]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(6); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [routerLink]="['external-events']" *LOSxHasPermission="'READ_EXTERNAL_EVENT_CONFIGURATION'">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['external-events']">
                <mat-icon matListIcon>
                  <fa-icon icon="anchor" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Manage External Events' | translate }}
                  @if (arrowBooleans[7]) {
                    <p matLine [routerLink]="['external-events']" class="menu-explanation">
                      {{ 'labels.text.External Events configuration, to enable or disable' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[7]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(7); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[7]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(7); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="flex-50">
        <mat-nav-list>
          <mat-list-item [routerLink]="['audit-trails']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['audit-trails']">
                <mat-icon matListIcon>
                  <fa-icon icon="money-check" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Audit Trails' | translate }}
                  @if (arrowBooleans[8]) {
                    <p matLine [routerLink]="['audit-trails']" class="menu-explanation">
                      {{ 'labels.text.Audit logs of all the activities' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[8]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(8); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[8]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(8); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <div #manageReports>
            <mat-list-item [routerLink]="['reports']">
              <div class="menu-list-item-content">
                <div class="menu-left-section" [routerLink]="['reports']">
                  <mat-icon matListIcon>
                    <fa-icon icon="file-word" size="sm"></fa-icon>
                  </mat-icon>
                  <div matLine>
                    {{ 'labels.heading.Manage Reports' | translate }}
                    @if (arrowBooleans[9]) {
                      <p matLine [routerLink]="['reports']" class="menu-explanation">
                        {{ 'labels.text.Add new report and classify reports' | translate }}
                      </p>
                    }
                  </div>
                </div>
                <div class="menu-right-section">
                  @if (!arrowBooleans[9]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(9); $event.stopPropagation()"
                      icon="arrow-down"
                      size="md"
                    ></fa-icon>
                  }
                  @if (arrowBooleans[9]) {
                    <fa-icon
                      (click)="arrowBooleansToggle(9); $event.stopPropagation()"
                      icon="arrow-up"
                      size="md"
                    ></fa-icon>
                  }
                </div>
              </div>
            </mat-list-item>
          </div>

          <mat-list-item [routerLink]="['manage-jobs']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['manage-jobs']">
                <mat-icon matListIcon>
                  <fa-icon icon="clock" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Manage Jobs' | translate }}
                  @if (arrowBooleans[10]) {
                    <p matLine [routerLink]="['manage-jobs']" class="menu-explanation">
                      {{ 'labels.text.Manage Schedule and Workflow jobs, modify jobs' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[10]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(10); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[10]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(10); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [routerLink]="['configurations']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['configurations']">
                <mat-icon>
                  <fa-icon icon="cogs" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Configurations' | translate }}
                  @if (arrowBooleans[11]) {
                    <p matLine [routerLink]="['configurations']" class="menu-explanation">
                      {{ 'labels.text.Global configurations, Cache and Business Date' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[11]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(11); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[11]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(11); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [routerLink]="['account-number-preferences']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['account-number-preferences']">
                <mat-icon matListIcon>
                  <fa-icon icon="key" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Account Number Preferences' | translate }}
                  @if (arrowBooleans[12]) {
                    <p matLine [routerLink]="['account-number-preferences']" class="menu-explanation">
                      {{ 'labels.text.Preferences for generating account numbers for client' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[12]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(12); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[12]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(12); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [routerLink]="['external-services']">
            <div class="menu-list-item-content">
              <div class="menu-left-section" [routerLink]="['external-services']">
                <mat-icon matListIcon>
                  <fa-icon icon="cog" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.External Services' | translate }}
                  @if (arrowBooleans[13]) {
                    <p matLine [routerLink]="['external-services']" class="menu-explanation">
                      {{ 'labels.text.External Services Configuration' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[13]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(13); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[13]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(13); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>

          <mat-list-item [ngClass]="{ 'disabled-item': isDisabled }">
            <div class="menu-list-item-content">
              <div class="menu-left-section">
                <mat-icon matListIcon>
                  <fa-icon icon="key" size="sm"></fa-icon>
                </mat-icon>
                <div matLine>
                  {{ 'labels.heading.Two-Factor Authentication' | translate }}
                  @if (arrowBooleans[14]) {
                    <p matLine class="menu-explanation">
                      {{ 'labels.text.Two-factor authentication configuration' | translate }}
                    </p>
                  }
                </div>
              </div>
              <div class="menu-right-section">
                @if (!arrowBooleans[14]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(14); $event.stopPropagation()"
                    icon="arrow-down"
                    size="md"
                  ></fa-icon>
                }
                @if (arrowBooleans[14]) {
                  <fa-icon
                    (click)="arrowBooleansToggle(14); $event.stopPropagation()"
                    icon="arrow-up"
                    size="md"
                  ></fa-icon>
                }
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>

<ng-template #templateDatatables let-popover="popover">
  <h2>{{ 'labels.heading.Manage Data Tables' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.LOS X data-tables allow the user to add custom fields' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepDatatables()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepDatatables()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateCodes let-popover="popover">
  <h2>{{ 'labels.heading.Manage Codes' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Selection you can create new drop-downs and edit' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepCodes()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepCodes()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateRolesandPermission let-popover="popover">
  <h2>{{ 'labels.heading.Manage Roles and Permissions' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Roles and Permissions allow the administrator to control access' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepRolesandPermission()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepRolesandPermission()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateMakerCheckerTable let-popover="popover">
  <h2>{{ 'labels.heading.Configure Maker-Checker Tasks' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.“Maker-Checker” principle requires every tasks' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepMakerCheckerTable()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepMakerCheckerTable()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateConfigurations let-popover="popover">
  <h2>{{ 'labels.heading.Configuration' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Configurations page allows you to further customize' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepConfigurations()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepConfigurations()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateSchedulerJobs let-popover="popover">
  <h2>{{ 'labels.heading.Manage Scheduler Jobs' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Scheduler Jobs can set batch jobs' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepSchedulerJobs()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepSchedulerJobs()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateManageReports let-popover="popover">
  <h2>{{ 'labels.heading.Manage Reports' | translate }}</h2>
  <p class="mw300">{{ 'labels.text.Add customized reports and edit core reports' | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStepManageReports()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStepManageReports()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
